import React from "react";
import { Chip } from "@mui/material";

const Tag = ({ label, height }) => {
  return (
    <Chip
      label={label.toUpperCase()}
      sx={{
        height: height || null,
        backgroundColor: "#bb1fe2",
        color: "#fff",
        fontSize: "10px",
        letterSpacing: "2px",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#bb1fe2", // Slightly darker on hover
        },
      }}
    />
  );
};

export default Tag;
